import { render, staticRenderFns } from "./areaDispose.vue?vue&type=template&id=007cc15a&scoped=true&"
import script from "./areaDispose.vue?vue&type=script&lang=js&"
export * from "./areaDispose.vue?vue&type=script&lang=js&"
import style0 from "./areaDispose.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./areaDispose.vue?vue&type=style&index=1&id=007cc15a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007cc15a",
  null
  
)

export default component.exports